import { useState, type FormEvent } from "react";

const FORM_ADDR = "https://readdy.ai/api/form/dag490rep053ijub23j0";

interface Status {
  kind: "idle" | "loading" | "success" | "error";
  msg: string;
}

export default function Newsletter() {
  const [status, setStatus] = useState<Status>({ kind: "idle", msg: "" });

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const fd = new FormData(form);

    const honeypot = String(fd.get("website_alt") || "").trim();
    const email = String(fd.get("email") || "").trim();
    if (!email) {
      setStatus({ kind: "error", msg: "请填写正确的邮箱地址后再订阅。" });
      return;
    }
    // 若蜜罐被填写（机器人），假装成功但不提交
    if (honeypot) {
      setStatus({ kind: "success", msg: "订阅成功！最快热点速递将发送到你的邮箱。" });
      form.reset();
      return;
    }
    if (honeypot === "") {
      fd.delete("website_alt");
    }

    setStatus({ kind: "loading", msg: "正在提交…" });
    try {
      const res = await fetch(FORM_ADDR, { method: "POST", body: fd });
      const text = await res.text();
      let code = "";
      let serverMsg = "";
      try {
        const parsed = JSON.parse(text);
        code = parsed?.code || "";
        serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      } catch {
        serverMsg = text;
      }
      if (res.ok && code === "OK") {
        setStatus({ kind: "success", msg: "订阅成功！最快热点速递将发送到你的邮箱。" });
        form.reset();
      } else {
        setStatus({ kind: "error", msg: serverMsg || "订阅失败，请稍后重试。" });
      }
    } catch {
      setStatus({ kind: "error", msg: "网络似乎开小差了，请稍后重试。" });
    }
  };

  return (
    <section id="contact" className="border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 items-center gap-8 px-4 md:px-6 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.22em] text-primary-600 uppercase">
            <span className="h-px w-6 bg-primary-500" />
            订阅速递
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
            每天最热的瓜，<br className="hidden md:block" />
            <span className="text-primary-600">一条速递送到你面前</span>
          </h2>
          <p className="mt-4 max-w-lg text-sm leading-relaxed text-foreground-600 md:text-base">
            留下邮箱，热点一有新进展，编辑部就把浓缩版进展摘要发给你。不打扰，只在有瓜时出现。也可以随时退订。
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-foreground-600">
            <span className="inline-flex items-center gap-2">
              <i className="ri-mail-send-line text-primary-500" />
              suye@readdy.example
            </span>
            <span className="inline-flex items-center gap-2">
              <i className="ri-time-line text-primary-500" />
              每日 19:00 前后推送
            </span>
          </div>
        </div>

        <div className="rounded-2xl border border-background-200 bg-background-100/60 p-6 md:p-8">
          <form
            data-readdy-form="宿野吃瓜 热点速递订阅"
            onSubmit={submit}
            noValidate
            className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-0 sm:rounded-full sm:bg-background-50 sm:p-1.5 sm:shadow-none"
          >
            <label className="relative flex-1">
              <span className="sr-only">邮箱地址</span>
              <i className="ri-mail-line absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-400 sm:left-5" />
              <input
                type="email"
                name="email"
                autoComplete="email"
                required
                placeholder="输入你的邮箱地址"
                className="h-[52px] w-full rounded-full border border-background-200 bg-background-50 pl-12 pr-4 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-300 sm:h-11 sm:border-0 sm:bg-transparent sm:focus:border-0"
              />
            </label>
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="hp-trap"
            />
            <button
              type="submit"
              disabled={status.kind === "loading"}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60 sm:py-2.5"
            >
              {status.kind === "loading" ? "提交中…" : "立即订阅"}
              {status.kind !== "loading" && <i className="ri-arrow-right-line" />}
            </button>
          </form>
          <div className="mt-4 min-h-6">
            {status.kind === "success" && (
              <p className="flex items-center gap-2 text-sm font-medium text-secondary-800">
                <i className="ri-checkbox-circle-fill" /> {status.msg}
              </p>
            )}
            {status.kind === "error" && (
              <p className="flex items-center gap-2 text-sm font-medium text-primary-700">
                <i className="ri-error-warning-fill" /> {status.msg}
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}